<template>
    <div class="w-100">
        <v-combobox
            :items="searchResults"
            :search-input.sync="location"
            label="Nom de l'établissement"
            style="padding-top: 0 !important;"
            v-model="locationTxt"
            class="mr-4"
            no-data-text="Saisissez pour rechercher un établissement"
            prepend-inner-icon="place"
            item-text="description"
            outlined>
        </v-combobox>
    </div>
</template>

<script>
import { mapState } from "vuex"
export default {
    name: "Places",
    data() {
        return {
            searchResults: [],
            service: null,
            location: null,
            locationTxt: null
        }
    },
    metaInfo () {
        return {
            script: [{
                src: `https://maps.googleapis.com/maps/api/js?key=AIzaSyCZHjpJOcB5SUZjCmqNnzJT1gdNymcaCrk&libraries=places`,
                async: true,
                defer: true,
                callback: () => this.MapsInit() // will declare it in methods
            }]
        }
    },
    methods: {
        MapsInit () {
            this.service = new window.google.maps.places.AutocompleteService()
        },
        displaySuggestions (predictions, status) {
            if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
                this.searchResults = []
                return
            }
            this.searchResults = predictions
        }
    },
    watch: {
        location (newValue) {
            if (newValue) {
                this.service.getPlacePredictions({
                    input: this.location,
                    types: ['establishment'],
                    componentRestrictions: { country: this.country },
                }, this.displaySuggestions)
            }
        },
        locationTxt(value) {
            this.$global.$emit('google-search', value)
        }
    },
    computed: {
        ...mapState('account', ['account']),
        country() {
            return this.account.tis_type.code === 'DAHUB_QUEBEC' ? 'ca' : 'fr'
        }
    },
    created() {
        this.$global.$on('clear-places', () => {
            this.location    = null
            this.locationTxt = null
        })
    },
    beforeDestroy() {
        this.$global.$off('clear-places')
    }
}
</script>
